var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-popover',{attrs:{"placement":"bottom","trigger":"hover","width":"250","disabled":!_vm.$slots.default && !_vm.content}},[_c('VIcon',{attrs:{"slot":"reference","type":"question-balloon-o"},slot:"reference"}),_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.content)+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }